import HoldingReportsActions from "@redux/actions/Reports/HoldingReport";
import DashboardHoldingSummaryActions from "@redux/actions/Reports/DashboardHoldingSummary";
export var DashBoardActions = new DashboardHoldingSummaryActions();
export default (function () {
    return new HoldingReportsActions();
});
